import axios from "axios";

const API_URL = "";

const axiosApi = axios.create({
    baseURL: API_URL,
    timeout: 10000000,
});

axiosApi.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
);

// axiosApi.defaults.withCredentials = true;
axiosApi.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem("accessToken");
        config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    async (error) => Promise.reject(await error),
);

export async function get(url, config = {}) {
    return await axiosApi
        .get(url, { ...config })
        .then((response) => response.data);
}

export async function getAddress(url, config = {}) {
    return await axiosApi
        .get(url, { ...config })
        .then((response) => response.data);
}

export async function post(url, data, config = {}) {
    return axiosApi
        .post(url, { ...data }, { ...config })
        .then((response) => response.data);
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then((response) => response.data);
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, { ...config })
        .then((response) => response.data);
}
export async function delMany(url, { type, ids }, config = {}) {
    return await axiosApi
        .delete(url, {
            ...config,
            data: { type, ids },
        })
        .then((response) => response.data)
        .catch((error) => {
            throw new Error(`Failed to delete: ${error.message}`);
        });
}
